// extracted by mini-css-extract-plugin
export default {"mainContainer":"LoadingScreen_mainContainer__d1MMF"};